import { inject, Injectable, signal } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  modalVisibility = signal<boolean>(false);

  data = signal<any>(null);
  _snackBar = inject(MatSnackBar);
  horizontalPosition: MatSnackBarHorizontalPosition = "end";
  verticalPosition: MatSnackBarVerticalPosition = "bottom";

  openModal(data?: any) {
    this.data.set(data);
    this.modalVisibility.set(true);
  }

  closeModal() {
    this.modalVisibility.set(false);
  }

  notifier(title: any, message: any, statut: any) {
    this._snackBar.open(title, message, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 5000,
      panelClass:
        statut == "error"
          ? ["alert-background-red"]
          : statut == "success"
          ? ["alert-background-green"]
          : ["alert-background-brown"],
    });
  }
}
  
